import React from 'react';
import { CenterFilters } from '../../../../app/models/Center';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';

type Props = {
  filter: CenterFilters;
  setFilter: (filter: CenterFilters) => void;
  onSearch: () => void;
};

type FilterKey = 'id' | 'name' | 'address';

const CenterFilter = ({ filter, setFilter, onSearch }: Props) => {
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    const key = name as FilterKey;
    const next: Partial<CenterFilters> = { ...filter, page: 1 };
    if (key === 'id') {
      next.id = value === '' ? null : parseInt(value, 10) || null;
    } else {
      (next as Record<string, unknown>)[key] = value;
    }
    setFilter(next as CenterFilters);
  };

  const doSearch = (e?: React.FormEvent) => {
    e?.preventDefault?.();
    onSearch();
  };

  return (
    <form onSubmit={doSearch}>
      <div className="row g-2 align-items-end">
        <div className="col-md-auto">
          <label className="form-label small mb-1" htmlFor="id">
            Id Centro
          </label>
          <input
            type="text"
            id="id"
            name="id"
            className="form-control form-control-sm"
            placeholder="Ej: 1"
            value={filter.id != null ? String(filter.id) : ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-auto">
          <label className="form-label small mb-1" htmlFor="name">
            Nombre
          </label>
          <input
            type="text"
            id="name"
            name="name"
            className="form-control form-control-sm"
            placeholder="Ej: HACIENDA 1"
            value={filter.name ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-auto">
          <label className="form-label small mb-1" htmlFor="address">
            Dirección
          </label>
          <input
            type="text"
            id="address"
            name="address"
            className="form-control form-control-sm"
            placeholder="Ej: CAM PUBLICO LT 4"
            value={filter.address ?? ''}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-auto">
          <ButtonSearchFilter callbackSearch={doSearch} />
        </div>
      </div>
    </form>
  );
};

export default CenterFilter;
